import { cn } from "utils";
import NextImage from "./NextImage";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/Empty";

const I18n = I18nUtil.createScoped(Translations);

export interface EmptyStateProps {
  title?: string;
  description?: string;
  image?: string;
  className?: string;
  descriptionClassName?: string;
  titleClassName?: string;
  hideDescription?: boolean;
  hideImage?: boolean;
}

export const EmptyState = ({
  title,
  description,
  image,
  className,
  descriptionClassName,
  titleClassName,
  hideDescription,
  hideImage,
}: EmptyStateProps) => (
  <div
    className={cn(
      "flex flex-col justify-center items-center w-full",
      className,
    )}
  >
    {!hideImage && (
      <NextImage
        src={image || "/assets/images/agent-empty-light.webp"}
        alt="empty"
        width={120}
        height={120}
      />
    )}

    <span
      className={cn(
        "title_m text-content_secondary mt-3 mb-1",
        titleClassName,
      )}
    >
      {title || I18n.t("No Data Yet")}
    </span>
    {!hideDescription && (
      <span
        className={cn(
          "body_s text-content_tertiary text-center inline-block whitespace-normal break-words",
          descriptionClassName,
        )}
      >
        {description ||
          I18n.t("No data yet, but exciting updates are on the horizon!")}
      </span>
    )}
  </div>
);
